{
  "nl": {
    "aiPersona": {
      "confirm": {
        "deleteConversation": {
          "text": "Deze actie kan niet ongedaan worden gemaakt. Het gesprek wordt permanent verwijderd met alle berichten.",
          "title": "Gesprek verwijderen?"
        }
      },
      "defaults": {
        "description": "Voer een gesprek met een chatbot die in de rol van {name} kruipt."
      },
      "disclaimer": "Dit is een chat met Kunstmatige Intelligentie (AI). De antwoorden zijn verzonnen. De AI probeert echter te doen alsof het de betreffende persoon is. Probeer het uit, stel vragen, maar blijf kritisch en voer indien nodig feitenchecks uit. Veel plezier!",
      "emptyState": {
        "title": "Welke rol moet je chatbot spelen?",
        "description": "Kies een rol: voer de naam van een historische of fictieve figuur in en start het rollenspel.",
        "hint": "<strong>Vergeet je eigen intelligentie niet:</strong> AI kan menselijk overkomen, maar is een machine. Bekijk de antwoorden altijd kritisch.",
        "createButton": "Nieuwe rol aanmaken"
      },
      "deprecationAlert": {
        "title": "Let op: dit gebied wordt momenteel verbouwd!",
        "description": "Om misverstanden bij het omgaan met AI te voorkomen, zijn er hier geen voorbereide rollen meer. Je kunt echter nog steeds chatbots met eigen rollen aanmaken.",
        "hint": "Tip: In onze AI-Assistentencatalogus vind je een grote selectie samengestelde AI-assistenten en kant-en-klare rollen-chatbots.",
        "catalogLink": "Naar de AI-Assistentencatalogus"
      },
      "historyAlert": {
        "title": "Let op: dit gebied verhuist binnenkort!",
        "description": "In de toekomst vind je al je eerdere gesprekken alleen nog in de AI-Chat en kun je daar nieuwe chatbots aanmaken.",
        "chatLink": "Naar de AI-Chat"
      },
      "flash": {
        "nameNotPermitted": "Deze rol kan niet worden aangemaakt."
      },
      "labels": {
        "name": "Naam van de rol"
      },
      "links": {
        "myAssistants": "Naar mijn assistenten en chatbots",
        "newPersona": "Nieuwe rol aanmaken"
      },
      "categories": {
        "my": "Mijn Assistenten"
      },
      "personaForm": {
        "heading": "Stel de rol van de chatbot in",
        "create": "Aanmaken"
      }
    }
  }
}
